export default class currentCompany {
    id
    image
    integrated
    name
    remainingPoints
    primaryColor
    buttonsColor

    constructor( object ) {
        this.id = object.id
        this.image = ( object && object.image )? object.image : '@/assets/default-user-intern.png';
        this.integrated = object.integrated 
        this.name = object.name
        this.remainingPoints = ( object && object.remainingPoints )? object.remainingPoints : 0;        
        this.buttonsColor = object.buttonsColor
        this.primaryColor = object.primaryColor
        this.fontColor = object.fontColor
    }
}